import { CheckOutlined, CloseOutlined } from "@material-ui/icons";
import {
	CircularProgress,
	ListItem,
	ListItemIcon,
	ListItemText,
} from "@mui/material";
import React, { useEffect } from "react";
import { ValidationProps } from "./ValidateAPITypes";
import { useSelector } from "react-redux";
import { setValidationStatus } from "../../stateManagement/actions/validateAPIActions";
import { validationFunctionMap } from "../../services/validateAPIService";
import store from "../../stateManagement/store";

const Validation = (props: ValidationProps): JSX.Element => {
	const { name, params, loading, responseData, validateId, id } = props;
	const currentStatus = useSelector(() => store.getState().validateAPIState?.validationStatus[id])

	async function calculateStatus(validateId: string, data: any) {
		try {
			setValidationStatus("inProgress", id)
			const status = await validateData(validateId, data);
			if (status) {
				setValidationStatus("success", id)
			} else {
				setValidationStatus("failure", id)
			}
		} catch (err) {
			console.error(err);
			setValidationStatus("failure", id);
		}
	}

	const validateData = async (id: string, data: any) => validationFunctionMap[id] ? await validationFunctionMap[id](data, params) : false;

	useEffect(() => {
		if (responseData && responseData?.type !== "error") {
			calculateStatus(validateId, responseData.data);
		} else if (responseData && responseData?.type === "error") {
			setValidationStatus("failure", id)
		}
	}, [responseData]);

	useEffect(() => {
		if (loading && currentStatus !== "inProgress")
			setValidationStatus("inProgress", id)
	}, [loading])

	return (
		<ListItem className="validation-item">
			<ListItemText
				primary={name}
				primaryTypographyProps={{
					fontWeight: "medium",
					variant: "body2",
				}}
			/>
			<ListItemIcon className="validation-item-icon">
				{currentStatus === "inProgress" ? (
					<CircularProgress size={20} />
				) : currentStatus === "success" ? (
					<CheckOutlined className="validate-success" />
				) : currentStatus === "failure" ? (
					<CloseOutlined className="validate-failure" />
				) : (
					"-"
				)}
			</ListItemIcon>
		</ListItem>
	);
};

export default Validation;
